// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_errorboxalert__rqZ5p{
    border-bottom: 1px solid var(--referral-theme-danger);
}
.input_fullerrorbox__wfnPo{
    border: 2px solid var(--referral-theme-danger);
    border-radius: 8px;
    position: relative;
}
.input_inputAlertIcon__DRCyg {
    width: 20px;
    height: 20px;
    margin: 0px 10px 0px 5px;
}
.input_blackbox__xFw0P{
    border-bottom: 1px solid var(--referral-black);
}
.input_labelWithoutError__dixf3{
    margin-bottom: 10px;
    border: 2px solid var(--referral-border-color);
    border-radius: 8px;
    position: relative;
    height: 53px;
    padding: 10px;
}
.input_calenderBodyItemDateStartError__gqyvj{
    border: 1px solid var(--referral-theme-danger);
}
.input_calenderBodyItemDateEndError__bCjuB{
    border: 1px solid var(--referral-theme-danger);
}

.input_redalertextra__9xLHq{ 
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 10px;
}
.input_redalertextra__9xLHq:focus{
    background: var(--referral-gray-shade4);
}`, "",{"version":3,"sources":["webpack://./src/components/Input/input.module.css"],"names":[],"mappings":"AAAA;IACI,qDAAqD;AACzD;AACA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,8CAA8C;AAClD;AACA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,8CAA8C;AAClD;AACA;IACI,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;AACjB;AACA;IACI,uCAAuC;AAC3C","sourcesContent":[".errorboxalert{\n    border-bottom: 1px solid var(--referral-theme-danger);\n}\n.fullerrorbox{\n    border: 2px solid var(--referral-theme-danger);\n    border-radius: 8px;\n    position: relative;\n}\n.inputAlertIcon {\n    width: 20px;\n    height: 20px;\n    margin: 0px 10px 0px 5px;\n}\n.blackbox{\n    border-bottom: 1px solid var(--referral-black);\n}\n.labelWithoutError{\n    margin-bottom: 10px;\n    border: 2px solid var(--referral-border-color);\n    border-radius: 8px;\n    position: relative;\n    height: 53px;\n    padding: 10px;\n}\n.calenderBodyItemDateStartError{\n    border: 1px solid var(--referral-theme-danger);\n}\n.calenderBodyItemDateEndError{\n    border: 1px solid var(--referral-theme-danger);\n}\n\n.redalertextra{ \n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding: 10px;\n}\n.redalertextra:focus{\n    background: var(--referral-gray-shade4);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorboxalert": `input_errorboxalert__rqZ5p`,
	"fullerrorbox": `input_fullerrorbox__wfnPo`,
	"inputAlertIcon": `input_inputAlertIcon__DRCyg`,
	"blackbox": `input_blackbox__xFw0P`,
	"labelWithoutError": `input_labelWithoutError__dixf3`,
	"calenderBodyItemDateStartError": `input_calenderBodyItemDateStartError__gqyvj`,
	"calenderBodyItemDateEndError": `input_calenderBodyItemDateEndError__bCjuB`,
	"redalertextra": `input_redalertextra__9xLHq`
};
export default ___CSS_LOADER_EXPORT___;
